<template>
  <v-card>
    <v-data-table
      :headers="headersCrud"
      :items="dataCrud"
      dense
      class="elevation-1 mx-auto pa-0 secundary5"
      style="width: 100%"
      @click:row="clickRowInfo"
    >
      <template v-slot:item[`index`]="{ index }">
        {{ index + 1 }}
      </template>
      <template v-slot:top>
        <v-toolbar flat height="10" class="secundary5">
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="900px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                dark
                color="primary"
                x-small
                v-bind="attrs"
                v-on="on"
                width="25"
                height="25"
                class="mr-6"
                v-if="observerHCP === false"
                v-show="!isRouteDetailsSymp"
              >
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
            </template>
            <v-card class="mt-13">
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text class="pb-0">
                <v-container>
                  <form>
                    <v-row>
                      <v-col
                        v-for="(field, index) in formCrud"
                        :key="index"
                        :cols="field.cols"
                        :sm="field.sm"
                        :md="field.md"
                        :lg="field.lg"
                        class="pb-1"
                      >
                        <component
                          :is="field.component"
                          :label="field.label"
                          :type="field.type"
                          :items="field.items"
                          v-bind="{ ...field.props }"
                          v-model="editedItem[field.vModel]"
                          @change="handleEvents"
                        ></component>
                      </v-col>
                      <span v-if="!isRouteDetailsSymp" class="d-flex text-caption justify-end mx-4 mt-3 font-class-name">{{
                        spanMsg
                      }}</span>
                    </v-row>
                  </form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close"> Cancelar </v-btn>
                <v-btn color="blue darken-1" text @click="save"> Guardar </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="350px">
            <v-card>
              <v-card-title class="text-body-1">
                ¿Seguro que desea eliminar este item?
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"> Cancelar </v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm(), remove()">
                  Eliminar
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }" v-if="observerHCP === false">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)" v-if="!isRouteDetailsSymp"> mdi-delete </v-icon>
      </template>
    </v-data-table>
    <v-col cols="12" class="d-flex justify-end secundary5" v-if="isRouteCheckbox">
      <v-checkbox
        :input-value="checkboxNone"
        @change="handleEventsbox"
        label="Ninguno"
        hide-details
        v-if="observerHCP === false"
      ></v-checkbox>
      <v-checkbox
        :value="checkboxNone"
        :readonly="true"
        :ripple="false"
        label="Ninguno"
        color="primary"
        hide-details
        v-else
      ></v-checkbox>
    </v-col>
  </v-card>
</template>

<script>
export default {
  name: 'VCrud',
  props: [
    'headersCrud',
    'dataCrud',
    'formCrud',
    'editedItems',
    'defaultItems',
    'spanMsg',
    'checkboxNone',
    'handleEvents',
    'handleEventsbox',
    'clickRowInfo',
    'remove',
    'observerHCP',
  ],
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
    };
  },
  handleEvents() {},
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Ingresar' : 'Editar';
    },
    isRouteCheckbox() {
      switch (this.$route.name) {
        case 'dysfunctions':
          return true;
        case 'symptoms-muscular':
          return true;
        case 'memory':
          return true;
        case 'losses':
          return true;
        case 'specific-situations':
          return true;
        default:
          return false;
      }
    },
    isRouteDetailsSymp() {
      return this.$route.name === 'details-symptoms';
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    $route(to) {
      document.body.classList.remove('page-data-crud'); // quitar clase vieja
      if (to.name === 'details-symptoms') {
        document.body.classList.add('page-data-crud'); // agregar clase solo para esa ruta
      }
    },
  },
  mounted() {
    if (this.$route.name === 'details-symptoms') {
      document.body.classList.add('page-data-crud');
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    update(editedItem, defaultItem) {
      this.$emit('update:editedItems', { ...editedItem });
      this.$emit('update:defaultItems', { ...defaultItem });
    },
    initialize() {
      this.dataCrud;
    },
    editItem(item) {
      this.editedIndex = this.dataCrud.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.dataCrud.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      const updated = this.dataCrud.filter((_, index) => index !== this.editedIndex);

      this.$emit('update:dataCrud', updated);
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      const base = Array.isArray(this.dataCrud) ? this.dataCrud : [];
      let updated;

      if (this.editedIndex > -1) {
        updated = base.map((item, index) =>
          index === this.editedIndex ? { ...item, ...this.editedItem } : item
        );
      } else {
        updated = [...base, { ...this.editedItem }];
      }

      this.$emit('update:dataCrud', updated);
      this.close();
    }
  },
};
</script>

<style>
.font-class-name {
  font-size: 3px !important;
}
body.page-data-crud .v-data-table.secundary5 th {
  padding: 0px 13px 0px 13px !important; 
  margin: 0px 6px 0px 6px !important;     
  text-align: center !important; 
}
body.page-data-crud .v-data-table.secundary5 th:first-child {
  text-align: start !important; 
  padding: 0px 10px 0px 0px !important; 
  margin: 0px 6px 0px 0px !important;         
}
body.page-data-crud .v-data-table.secundary5 td {
  font-size: 12px !important; 
  line-height: 1;  
  padding: 1px 13px 1px 13px !important; 
  margin: 0px !important;        
  text-align: center !important;        
}
body.page-data-crud .v-data-table.secundary5 td:first-child {
  text-align: start !important; 
  padding: 0px 10px 0px 0px !important; 
  margin: 0px 6px 0px 0px !important;   
}

</style>
